var v1="<div class=\"lbaLeafletMap\"> <div class=\"map\" ng-attr-id=\"{{vm.mapId}}\"></div> </div>";
window.angular.module(["ng"]).run(["$templateCache",function(c){c.put("components/lbaLeafletMap/lbaLeafletMapTemplate.html", v1)}]);
module.exports=v1;


//////////////////
// WEBPACK FOOTER
// ./src/components/lbaLeafletMap/lbaLeafletMapTemplate.html
// module id = 351
// module chunks = 0